import React, { createContext, useState, Dispatch, SetStateAction } from 'react';
import Cookies from 'js-cookie';

import IUseToast from 'common/types/IUseToast';

import useToast from './useToast';
import useModals from './useModals';
import IUseModals from 'common/types/IUseModals';

import ITheme from 'common/types/ITheme';


interface IUiContextValue extends IUseToast, IUseModals{
  setTheme: Dispatch<SetStateAction<ITheme>>,
  theme: string,
}

const UiContext = createContext<Partial<IUiContextValue>>({});

export const UiContextProvider = ({ children }: { children: React.ReactNode }) => {

  // theme
  const [theme, setTheme] = useState<ITheme>((Cookies.get('theme') ?? 'dark') as ITheme);

  // toast
  const { toasts, addToast, removeToast } = useToast();

  // modals
  const { closeModal, modal, openModal } = useModals();


  return <UiContext.Provider value={{
    addToast,
    closeModal,
    modal,
    openModal,
    removeToast,
    setTheme,
    theme,
    toasts,
  }}>{ children }</UiContext.Provider>;
};

export default UiContext;